<div class="layout-container">
  <!-- Menu -->
  <app-menu></app-menu>
  <!-- / Menu -->

  <!-- Layout container -->
  <div class="layout-page">
    <!-- Navbar -->

    <nav
      class="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme"
      id="layout-navbar"
    >
      <div class="container-fluid">
        <div
          class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
        >
          <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
            <i class="bx bx-menu bx-sm"></i>
          </a>
        </div>

        <div
          class="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse"
        >
          <ul class="navbar-nav flex-row align-items-center ms-auto">
            <li class="nav-item me-2">
              <app-live-date-time
                [DateTime]="backendDateTime"
              ></app-live-date-time>
            </li>
            <li
              class="nav-item me-2 animate__animated animate__delay-4-8s"
              [ngClass]="
                isRTL == true ? 'animate__fadeInLeft' : 'animate__fadeInRight'
              "
            >
              <div class="d-flex justify-content-center align-items-center">
                <small class="welcome-sm">
                  {{ "DrugStore" | translate }}
                </small>
                <small class="welcome-lg">
                  {{ "TopWelcomeSentenceFirstPart" | translate }}
                </small>
                <span class="drugstore-title fw-semibold d-block mx-2">
                  {{ thisUser.drugStoreName }}
                </span>
                <small class="welcome-lg">
                  {{ "TopWelcomeSentenceSecondPart" | translate }}
                </small>
              </div>
            </li>

            <!-- Language -->
            <language
              [classSize]="'fs-3'"
              [needAnimation]="true"
              [isRTL]="isRTL"
            ></language>
            <!--/ Language -->

            <!-- Notification -->
            <!-- <notification [isRTL]="isRTL"></notification> -->
            <!--/ Notification -->

            <li
              class="nav-item me-2 me-xl-0 animate__animated animate__delay-3-2s"
              [ngClass]="
                isRTL == true ? 'animate__fadeInLeft' : 'animate__fadeInRight'
              "
            >
              <a
                class="nav-link hide-arrow"
                href="javascript:void(0);"
                ngbTooltip="{{ 'topMenu.helptour' | translate }}"
                (click)="startTour()"
              >
                <i class="bx bx-sm bx-help-circle"></i>
              </a>
            </li>

            <!-- User -->
            <user-link [thisUser]="thisUser"></user-link>
            <!--/ User -->
          </ul>
        </div>

        <!-- Search Small Screens -->
        <div class="navbar-search-wrapper search-input-wrapper d-none">
          <input
            type="text"
            class="form-control search-input container-fluid border-0"
            placeholder="{{ 'Search' | translate }} ..."
            aria-label="Search..."
          />
          <i class="bx bx-x bx-sm search-toggler cursor-pointer"></i>
        </div>
      </div>
    </nav>

    <!-- / Navbar -->

    <!-- Content wrapper -->
    <div class="content-wrapper">
      <!-- Content -->

      <div class="container-xxl flex-grow-1 ps-3 pe-5">
        <!-- Layout Demo -->
        <div class="layout-demo-wrapper m-0">
          <router-outlet></router-outlet>
        </div>
        <!--/ Layout Demo -->
      </div>
      <!-- / Content -->

      <footer></footer>

      <div class="content-backdrop fade"></div>
    </div>
    <!-- Content wrapper -->
  </div>
  <!-- / Layout page -->
</div>

<!-- Overlay -->
<div class="layout-overlay layout-menu-toggle"></div>

<!-- Drag Target Area To SlideIn Menu On Small Screens -->
<!-- <div class="drag-target"></div> -->

<app-tour></app-tour>
<div class="side-button-box">
  <button
    class="w-100 d-flex justify-content-center align-items-center w-auto py-2 ps-2"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#ChangePrice"
    #changePriceButton
    aria-controls="ChangePrice"
    *ngIf="accessChangePriceNotification"
    (click)="changePriceShow = true"
  >
  <i class="fas fa-dollar-sign"></i>
  </button>
  <button
    class="w-100 d-flex justify-content-center align-items-center w-auto py-2 ps-2"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#InventoryBuyNeed"
    aria-controls="InventoryBuyNeed"
    #InventoryBuyNeedButton
    *ngIf="accessNeedToBuyNotification"
    (click)="needToBuyShow = true"
  >
    <i class="fa-solid fa-battery-quarter"></i>
  </button>
  <button
    class="w-100 d-flex justify-content-center align-items-center w-auto py-2 ps-2"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#check"
    #checkButton
    *ngIf="accessCheckNotification"
    aria-controls="check"
    (click)="checkShow = true"
  >
    <i class="fa-solid fa-money-check-dollar"></i>
  </button>
  <button
    class="w-100 d-flex justify-content-center align-items-center w-auto py-2 ps-2"
    type="button"
    data-bs-toggle="offcanvas"
    #InventoryExpireButton
    *ngIf="accessExpireNotification"
    data-bs-target="#InventoryExpire"
    aria-controls="InventoryExpire"
    (click)="expireShow = true"
  >
    <i class="fa-solid fa-clock-rotate-left"></i>
  </button>
</div>
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="ChangePrice"
  aria-labelledby="offcanvasEndLabel"
  style="z-index: 1000000000"
  *ngIf="accessChangePriceNotification"
  #changePrice
>
  <div class="offcanvas-header">
    <h5 id="offcanvasEndLabel" class="offcanvas-title">
      {{ "ChangePrice" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="changePriceShow = false"
    ></button>
  </div>
  <div class="offcanvas-body pt-0 mx-0 flex-grow-0">
    <div class="row">
      <div class="col-12 pb-2">
        <div class="row d-flex flex-row-reverse pb-3">
          <button
            type="button"
            placement="bottom"
            class="btn btn-icon ms-1 btn-outline-green"
            (click)="fetchChangePrice()"
          >
            <span class="tf-icons bx bx-refresh"></span>
          </button>
        </div>
        <div class="row px-2 pb-4 no-x-scroll">
          <ng-container *ngIf="changePriceShow">
            <ng-container
              *ngFor="let item of changePriceNotification; let i = index"
            >
              <div
                class="card py-0 px-1 mt-2 animate__animated animate__fadeInLeft"
                [style.animation-delay]="i * 0.2 + 's'"
              >
                <ng-container>
                  <div class="row">
                    <div class="col-6 ps-3 pt-1">
                      <h6 class="badge bg-success mb-1">
                        {{ "ChangePrice" | translate }}
                      </h6>
                    </div>
                    <div class="col-6 pe-3 pt-1 d-flex justify-content-end">
                      <button type="button" class="btn btn-icon btn-outline-success"
                        ngbTooltip="{{ 'Accept' | translate }}"
                        (click)="acceptChangePrice(item,i)"
                        >
                        <i class='bx bx-check' ></i>
                       </button>
                       <button type="button" class="btn btn-icon btn-outline-primary ms-1"
                        ngbTooltip="{{ 'Read' | translate }}"
                        (click)="readChangePrice(item,i)"
                        >
                        <i class='bx bx-show'></i>
                       </button>
                       <button type="button" class="btn btn-icon btn-outline-danger ms-1"
                        ngbTooltip="{{ 'Deny' | translate }}"
                        (click)="rejectChangePrice(item,i)"
                        >
                        <i class='bx bx-x'></i>
                       </button>
                    </div>
                    
                    <div class="col-12 px-3">
                      <small class="text-muted"
                        >{{ "DrugName" | translate }} :
                      </small>
                      <small>{{ item.drugName }}</small>
                    </div>
                    <div class="col-6 px-3 d-flex flex-column">
                      <small class="text-muted"
                        >{{ "OldBuyPrice" | translate }} :
                      </small>
                      <small>{{ item.oldBuyPrice | dataType : "price" }}</small>
                    </div>
                    <div class="col-6 px-3 d-flex flex-column">
                      <small class="text-muted"
                        >{{ "OldSellPrice" | translate }} :
                      </small>
                      <small>{{
                        item.oldSellPrice | dataType : "price"
                      }}</small>
                    </div>

                    <div class="col-6 px-3 mb-2 d-flex flex-column">
                      <small class="text-muted"
                        >{{ "NewBuyPrice" | translate }} :
                      </small>
                      <small>{{ item.newBuyPrice | dataType : "price" }}</small>
                    </div>
                    <div class="col-6 px-3 mb-2 d-flex flex-column">
                      <small class="text-muted"
                        >{{ "NewSellPrice" | translate }} :
                      </small>
                      <small>{{
                        item.newSellPrice | dataType : "price"
                      }}</small>
                    </div>
                    
                    
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="BarcodeGenerator"
  aria-labelledby="offcanvasEndLabel"
  style="z-index: 1000000000"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasEndLabel" class="offcanvas-title">
      {{ "BarcodeGenerator" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body pt-0 mx-0 flex-grow-0">
    <div class="row">
      <div class="col-12 border-bottom pb-2">
        <div class="row"></div>
      </div>
    </div>
  </div>
</div> -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  #InventoryBuyNeed
  id="InventoryBuyNeed"
  *ngIf="accessNeedToBuyNotification"
  aria-labelledby="offcanvasEndLabel"
  style="z-index: 1000000000"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasEndLabel" class="offcanvas-title">
      {{ "InventorySellNeedNotification" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="needToBuyShow = true"
    ></button>
  </div>

  <div class="offcanvas-body responsive-card pt-0 mx-0 flex-grow-0">
    <div class="row">
      <div class="col-12 pb-2">
        <div class="row d-flex flex-row-reverse pb-3">
          <button
            type="button"
            placement="bottom"
            class="btn btn-icon ms-1 btn-outline-warning"
            (click)="fetchDataNeedToBuy()"
          >
            <span class="tf-icons bx bx-refresh"></span>
          </button>
        </div>
        <div class="row px-2 pb-4 no-x-scroll">
          <ng-container *ngIf="needToBuyShow">
            <ng-container
              *ngFor="let item of needToBuyNotification; let i = index"
            >
              <div
                class="card col-12 py-0 px-1 mt-2 card-min-height animate__animated animate__fadeInLeft"
                [style.animation-delay]="i * 0.2 + 's'"
              >
                <div class="row">
                  <div class="col-12">
                    <div class="">
                      <h6 class="badge bg-info mb-1">
                        {{ "InventorySellNeed" | translate }}
                      </h6>
                    </div>
                    <div class="">
                      <p class="mb-1">{{ item.drugName }}</p>
                    </div>
                  </div>

                  <div class="col-2 battery-body">
                    <!-- <div class="sari-sharzher"></div>
                    <div class="battery">
                      <div class="charge"></div>
                    </div> -->
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="check"
  #check
  *ngIf="accessCheckNotification"
  aria-labelledby="offcanvasEndLabel"
  style="z-index: 1000000000"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasEndLabel" class="offcanvas-title">
      {{ "CheckNotification" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="checkShow = false"
    ></button>
  </div>
  <div class="offcanvas-body pt-0 mx-0 flex-grow-0">
    <div class="row">
      <div class="col-12 pb-2">
        <div class="row d-flex flex-row-reverse pb-3">
          <button
            type="button"
            placement="bottom"
            class="btn btn-icon ms-1 btn-outline-purple"
            (click)="fetchDataCheck()"
          >
            <span class="tf-icons bx bx-refresh"></span>
          </button>
        </div>
        <div class="row px-2 pb-4 no-x-scroll">
          <ng-container *ngIf="checkShow">
            <ng-container *ngFor="let item of checkNotification; let i = index">
              <div
                class="card col-12 card-min-height py-0 px-1 mt-2 animate__animated animate__fadeInLeft"
                [style.animation-delay]="i * 0.2 + 's'"
              >
                <ng-container>
                  <div class="col-12">
                    <h6 class="badge bg-danger mb-1">
                      {{ "Check" | translate }}
                    </h6>
                  </div>
                  <div class="col-12">
                    <p class="mb-1">{{ item.description }}</p>
                  </div>
                  <div class="col-12">
                    <small class="text-muted"
                      >{{ "checkPayTo" | translate }} :
                    </small>
                    <small>{{ item.reciver }}</small>
                  </div>
                  <div class="d-flex">
                    <div class="col-6">
                      <small class="text-muted"
                        >{{ "checkPriceNumber" | translate }} :
                      </small>
                      <small>{{ item.cost | dataType : "price" }}</small>
                    </div>
                    <div class="col-6">
                      <small class="text-muted"
                        >{{ "Date" | translate }} :
                      </small>
                      <small>{{ item.checkDate | dataType : "" }}</small>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  #InventoryExpire
  id="InventoryExpire"
  *ngIf="accessExpireNotification"
  aria-labelledby="offcanvasEndLabel"
  style="z-index: 1000000000"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasEndLabel" class="offcanvas-title">
      {{ "InventoryExpireNotification" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="expireShow=false"
    ></button>
  </div>
  <div class="offcanvas-body pt-0 mx-0 flex-grow-0">
    <div class="row">
      <div class="col-12 pb-2">
        <div class="row d-flex flex-row-reverse pb-3">
          <button
            type="button"
            placement="bottom"
            class="btn btn-icon ms-1 btn-outline-danger"
            (click)="fetchDataExpire()"
          >
            <span class="tf-icons bx bx-refresh"></span>
          </button>
        </div>
        <div class="row px-2 pb-4 no-x-scroll">
          <ng-container *ngIf="expireShow">

          <ng-container *ngFor="let item of expireNotification; let i = index">
            <div
              class="card col-12 card-min-height py-0 px-1 mt-2 animate__animated animate__fadeInLeft"
              [style.animation-delay]="i * 0.2 + 's'"
            >
              <div class="row">
                <div class="col-12">
                  <h6 *ngIf="item.forceSale" class="badge bg-warning mb-1">
                    {{ "ForceSale" | translate }}
                  </h6>
                  <h6 *ngIf="!item.forceSale" class="badge bg-info mb-1 ms-2">
                    {{ "InventoryExpire" | translate }}
                  </h6>
                  <h6 *ngIf="item.newBuyFactor" class="badge bg-danger mb-1 ms-2">
                    {{ "NewBuyFactor" | translate }}
                  </h6>
                </div>
                <div class="col-12">
                  <p class="mb-1">{{ item.brandName }}</p>
                </div>
                <div class="col-6">
                  <small class="text-muted">{{ "Stock" | translate }} : </small>
                  <small>{{ item.stockName }}</small>
                </div>
                <div class="col-6">
                  <small class="text-muted"
                    >{{ "Inventory" | translate }} :
                  </small>
                  <small>{{ item.count }}</small>
                </div>
                <div class="col-12">
                  <small class="text-muted">{{ "expireDate" | translate }} : </small>
                  <small>
                {{  calendarService.dayAgo(item.expireDate.toString()) }}
                </small>
                </div>
                <div class="col-12">
                  <small class="text-muted">{{ "buyDateTime" | translate }} : </small>
                  <small>{{ item.buyDateTime | dataType : "" }}</small>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>
